<template>
  <div
    class="hz-chat-header"
    v-if="currentConfig"
    :class="onlineStatus === 0 ? 'header-top' : ''"
    :style="{ backgroundColor: currentConfig.color }"
  >
    <div class="hz-chat-header-box">
      <div class="headimg">
        <img
          v-if="chatInfo"
          :src="
            (chatInfo.customerServerDto && chatInfo.customerServerDto.avatar) ||
            headimg
          "
          @click="headClick"
          class="avator"
          alt=""
        />
        <i class="hz-icon-_shuijue icon-_shuijue" v-show="!onlineStatus"></i>
        <i class="icon-online" v-show="onlineStatus"></i>
      </div>
      <div class="person-info">
        <div class="name">
          <span v-if="chatInfo">{{
            (chatInfo.customerServerDto && chatInfo.customerServerDto.nameEn) ||
            "Mary"
          }}</span>
          <span v-if="onlineStatus" class="online">Active</span>
        </div>
        <!--<div class="time" v-if="!onlineStatus"><i class="icon iconfont icon-_shijian"></i> Now {{currentTime}}.-->
        <!--Work from {{chatInfo.customerServerDto?(formatTime(chatInfo.customerServerDto.workBeginTime,'hh:mm:ss')):'08:00:00'}} ~-->
        <!--{{chatInfo.customerServerDto?(formatTime(chatInfo.customerServerDto.workEndTime,'hh:mm:ss')):'18:00:00'}}-->
        <!--</div>-->
        <div class="signature ellipsis" v-if="onlineStatus">
          {{
            (chatInfo.customerServerDto &&
              chatInfo.customerServerDto.signature) ||
            "Ask us anything, or share your feedback."
          }}
        </div>
        <div class="origin" v-if="chatInfo.customerServerDto">
          <a
            :href="chatInfo.customerServerDto.facebook"
            target="_blank"
            v-if="chatInfo.customerServerDto.facebook"
            ><i class="hz-icon-personal-icon-facebook"></i
          ></a>
          <a
            :href="chatInfo.customerServerDto.twitter"
            target="_blank"
            v-if="chatInfo.customerServerDto.twitter"
            ><i class="hz-icon-personal-icon-twitter"></i
          ></a>
          <a
            :href="chatInfo.customerServerDto.linkIn"
            target="_blank"
            v-if="chatInfo.customerServerDto.linkIn"
            ><i class="hz-icon-personal-icon-linkin"></i
          ></a>
          <a
            :href="chatInfo.customerServerDto.vk"
            target="_blank"
            v-if="chatInfo.customerServerDto.vk"
            ><i class="hz-icon-personal-icon-wk"></i
          ></a>

          <a
            :href="chatInfo.customerServerDto.youtube"
            target="_blank"
            v-if="chatInfo.customerServerDto.youtube"
            ><i class="hz-icon-personal-youtobe"></i
          ></a>
          <a
            :href="chatInfo.customerServerDto.pinterest"
            target="_blank"
            v-if="chatInfo.customerServerDto.pinterest"
            ><i class="hz-icon-personal-pinterest"></i
          ></a>
          <a
            :href="chatInfo.customerServerDto.tiktok"
            target="_blank"
            v-if="chatInfo.customerServerDto.tiktok"
            ><i class="hz-icon-personal-tiktok"></i
          ></a>

          <div
            class="emial-mobile-box"
            :class="
              chatInfo.customerServerDto.email &&
              chatInfo.customerServerDto.workPhoneNum
                ? 'two_line'
                : ''
            "
          >
            <a
              :href="'mailto:' + chatInfo.customerServerDto.email"
              target="_blank"
              v-if="chatInfo.customerServerDto.email"
            >
              <i class="hz-icon-personal-icon-email"></i
              >{{ chatInfo.customerServerDto.email }}</a
            >
            <!--                        <a :href="'tel:'+chatInfo.customerServerDto.workPhoneNum" style="color: #fff;text-decoration: none" target="_blank" v-if="chatInfo.customerServerDto.workPhoneNum"><i class="hz-icon-personal-icon-telephone" style="margin-right: 0px"></i>{{ chatInfo.customerServerDto.workPhoneNum }}</a>-->
          </div>
        </div>
      </div>
      <div class="header-right" v-if="chatInfo" v-show="chatInfo.isShowFlag">
        <img :src="chatInfo.avatar" class="nation-flag" alt="" />
        <img
          src="https://cdn.huazhi.cloud/flag/country_circle/cn.svg"
          class="nation-flag"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { store } from "../store";
import { defaultImg } from "../config/env";

export default {
  name: "chatHeader",
  data() {
    return {
      headimg: defaultImg,
      currentTime: 0,
    };
  },
  props: {
    onlineStatus: "",
    currentConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    chatInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    avator: "",
    lang: "",
  },
  created() {
    this.getCurrentTime();
    console.info(this.chatInfo);
  },
  computed: {
    showChatModel() {
      return store.showChatModel;
    },
  },

  methods: {
    headClick() {
      if (this.showChatModel) {
        this.$emit("click");
      }
    },

    getCurrentTime() {
      let _this = this;
      var date = new Date();
      let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minute =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let second =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      this.currentTime = hour + ":" + minute + ":" + second;
      setTimeout(function () {
        _this.getCurrentTime();
      }, 1000); //在1秒后再次执行
    },
    formatTime: function (date, fmt) {
      var date = new Date(date);
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          var str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
          );
        }
      }
      return fmt;
    },
  },
};
</script>

<style lang="scss" scoped>
#hz_chat_app {
  .hz-chat-header {
    height: 80px;
    width: 100%;
    background: #051e33;
    font-size: 14px;
    color: #ffffff;
    padding: 0 8px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    transition: 0.28s;
    .hz-chat-header-box {
      height: 100%;
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
    }
    /*&.header-top:hover {*/
    /*height: 95px;*/
    /*}*/

    /*&.header-top:hover .time {*/
    /*display: block;*/
    /*}*/

    .headimg {
      float: left;
      height: 80px;
      width: 56px;
      /*line-height: 80px;*/
      cursor: pointer;
    }
    .show-bottom {
      position: absolute;
      top: 80px;
      left: 0;
      height: 0px;
      width: 100%;
      background: #051e33;
      transition: height 0.28s;
    }

    .icon-_shuijue {
      position: absolute;
      left: 54px;
      top: 5px;
      display: inline;
      height: 18px;
      width: 18px;
      line-height: 18px;
      font-size: 14px;
      color: #ffff00;
    }
    .icon-online {
      position: absolute;
      left: 45px;
      top: 5px;
      display: inline-block;
      height: 17px;
      width: 17px;
      line-height: 18px;
      font-size: 14px;
      z-index: 9999;
      border-radius: 50%;
      background: #2fc25b;
    }
    .person-info {
      float: left;
      font-size: 14px;
      //height: 56px;
      //margin-top: 12px;
      margin-left: 18px;
      margin-left: 10px;
      flex: 1;
      overflow: hidden;
      line-height: 20px;
      height: inherit;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .person-info .name {
      text-align: left;
    }

    .header-right {
      width: 67px;
      height: 100%;
      position: absolute;
      right: 4px;
      top: 8px;
    }

    .header-right img.nation-flag {
      height: 29px;
      width: 29px;
    }

    .header-right img:nth-child(1) {
      margin-right: 8px;
    }

    .person-info .time {
      text-align: left;
      font-size: 12px;
      margin-top: 4px;
      display: block;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      /*text-overflow: ellipsis;*/
    }

    .person-info .signature {
      text-align: left;
      /*margin-top: 4px;*/
      font-size: 12px;
      line-height: 17px;
    }

    .person-info .origin {
      text-align: left;
      /*margin-top: 5px;*/
      //position: absolute;
      //z-index: 10;
      .emial-mobile-box {
        display: inline;
        a {
          color: #fff;
        }
        i {
          margin-right: 3px;
        }
      }
      .emial-mobile-box.two_line {
        display: inline-grid;
        vertical-align: middle;
        a {
          color: #fff;
          line-height: 14px;
          font-size: 13px;
          text-decoration: none;
          i {
            margin-right: 3px;
            font-size: 12px;
          }
        }
      }
    }

    .person-info .origin i {
      margin: 0;
      padding: 0;
      margin-right: 8px;
      font-size: 14px;
      margin-left: 0px;
      color: #dfdfdf;
    }

    .headimg img.avator {
      /*display: inline-block;*/
      /*vertical-align: middle;*/
      width: 56px;
      height: 56px;
      border-radius: 8px;
      margin-top: 13px;
    }
    .online {
      margin-left: 20px;
      margin-right: 20px;
    }

    .icon-_shijian {
      font-size: 12px;
      color: #ffffff;
    }
  }
}
</style>


